import { animate, query as q, style, transition, trigger } from '@angular/animations';

export function query(s, a, o = { optional: true }): any {
    return q(s, a, o);
}
export const routingTransition =

    trigger('routingTransition', [
        transition('* <=> *', [
            query(':enter',
                [
                    style({ opacity: 0 })
                ],
                { optional: true }
            ),

            query(':leave',
                [
                    style({ opacity: 1 }),
                    animate('0.1s', style({ opacity: 0 }))
                ],
                { optional: true }
            ),

            query(':enter',
                [
                    style({ opacity: 0 }),
                    animate('0.1s', style({ opacity: 1 }))
                ],
                { optional: true }
            )
        ])
    ]);
